import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { ClipboardCheck, Banknote, Settings2 } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { RequisitionsTab } from '../components/finance/RequisitionsTab';
import { WithdrawalsTab } from '../components/finance/WithdrawalsTab';
import { WorkflowSettingsTab } from '../components/finance/WorkflowSettingsTab';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function FinanceApprovalsPage() {
  const [taxonomy, setTaxonomy] = useState(null);
  const [projects, setProjects] = useState([]);
  const [workflow, setWorkflow] = useState(null);

  const loadCounts = useCallback(() => {
    axios.get(`${API_URL}/api/finance/overview`)
      .then((r) => setWorkflow(r.data.workflow)).catch(() => {});
  }, []);

  useEffect(() => {
    axios.get(`${API_URL}/api/finance/taxonomy`).then((r) => setTaxonomy(r.data)).catch(() => {});
    axios.get(`${API_URL}/api/projects`).then((r) => setProjects(r.data || [])).catch(() => {});
    loadCounts();
  }, [loadCounts]);

  return (
    <div className="space-y-6" data-testid="finance-approvals-page">
      <div>
        <h2 className="font-heading text-2xl font-semibold">Requisitions &amp; Approvals</h2>
        <p className="text-muted-foreground">Expense Request → Requisition → Review → Authorization → Payment → Verification</p>
      </div>

      {workflow && (
        <div className="grid grid-cols-3 gap-3">
          <Card><CardContent className="p-4">
            <p className="text-xs text-muted-foreground">Pending Requisitions</p>
            <p className="text-2xl font-heading font-bold text-blue-600" data-testid="kpi-pending-reqs">{workflow.pending_requisitions}</p>
          </CardContent></Card>
          <Card><CardContent className="p-4">
            <p className="text-xs text-muted-foreground">Approved — Awaiting Payment</p>
            <p className="text-2xl font-heading font-bold text-emerald-600" data-testid="kpi-awaiting-payment">{workflow.approved_awaiting_payment}</p>
          </CardContent></Card>
          <Card><CardContent className="p-4">
            <p className="text-xs text-muted-foreground">Unreconciled Withdrawals</p>
            <p className="text-2xl font-heading font-bold text-amber-600" data-testid="kpi-unreconciled">{workflow.unreconciled_withdrawals}</p>
          </CardContent></Card>
        </div>
      )}

      <Tabs defaultValue="requisitions">
        <TabsList data-testid="approvals-tabs">
          <TabsTrigger value="requisitions" data-testid="tab-requisitions">
            <ClipboardCheck className="h-4 w-4 mr-1.5" /> Expense Requisitions
          </TabsTrigger>
          <TabsTrigger value="withdrawals" data-testid="tab-withdrawals">
            <Banknote className="h-4 w-4 mr-1.5" /> Cash Withdrawals
          </TabsTrigger>
          <TabsTrigger value="settings" data-testid="tab-workflow-settings">
            <Settings2 className="h-4 w-4 mr-1.5" /> Workflow Settings
          </TabsTrigger>
        </TabsList>
        <TabsContent value="requisitions" className="mt-4">
          <RequisitionsTab taxonomy={taxonomy} projects={projects} onChanged={loadCounts} />
        </TabsContent>
        <TabsContent value="withdrawals" className="mt-4">
          <WithdrawalsTab onChanged={loadCounts} />
        </TabsContent>
        <TabsContent value="settings" className="mt-4">
          <WorkflowSettingsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
